import { MessageCircle, Navigation, Phone } from "lucide-react";
import { t } from "@/lib/i18n";

const ITEMS = [
  { key: "phone", label: "bar.call", Icon: Phone, testId: "mobile-bar-call-button" },
  { key: "whatsapp", label: "bar.whatsapp", Icon: MessageCircle, testId: "mobile-bar-whatsapp-button", external: true },
  { key: "directions", label: "bar.directions", Icon: Navigation, testId: "mobile-bar-directions-button", external: true },
];

export default function BottomBar({ links }) {
  const items = ITEMS.filter((i) => links[i.key]);
  return (
    <nav
      aria-label={t("bar.label")}
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-cream/95 backdrop-blur-md border-t border-line bar-safe safe-x pt-2"
      data-testid="mobile-bottom-bar"
    >
      <ul className="flex gap-2">
        {items.map(({ key, label, Icon, testId, external }) => (
          <li key={key} className="flex-1">
            <a
              href={links[key].href}
              {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              className="flex items-center justify-center gap-2 min-h-[52px] rounded-full bg-forest text-cream text-sm font-semibold active:scale-[0.98] transition-transform"
              data-testid={testId}
            >
              <Icon className="h-4 w-4" aria-hidden="true" />
              {t(label)}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
